
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Timeline from 'vux/src/components/timeline/timeline.vue'
import TimelineItem from 'vux/src/components/timeline/timeline-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import Upload from '@/components/UploadImage'
import CPosition from '@/components/Position'
export default {
name: 'Order',
directives: {
TransferDom
},
components: {
Cell,
Group,
Timeline,
TimelineItem,
XButton,
Flexbox,
FlexboxItem,
Upload,
XTextarea,
CPosition,
Confirm
},
data() {
return {
ID: '',
MEMO: '',
isComplete: false,
uploadParams: {},
color: 'red',
order: {},
orderFiles: [],
demageFiles: [],
th_orderFiles: null,
th_demageFiles: null,
hasOrderImg: false, // 是否已经提交送货交接单
hasDemageImg: false, // 是否已经提交破损交接单
isSubmit: false,
showConfirm: false,
confirmTitle: '',
stepForm: {}
}
},
computed: {
position() {
return this.$store.getters.getPosition
}
},
created() {
this.ID = this.$route.query.ID || ''
if (process.env.NODE_ENV != 'development' && this.$store.state.app.roleid != 0) {
this.$router.replace({
path: './sh/order?ID=' + this.ID
})
return;
}
this.uploadParams = {
SUBDIR: this.$config.SUBDIR.ps
}
this.loadData()
this.$store.dispatch('baiduPosition')
},
methods: {
loadData() {
let _this = this
_this.$vux.loading.show()
let url = 'Trans.ashx?action=Form_Load'
this.$post(url, {
ID: this.ID
}).then(
response => {
_this.order = response
_this.isComplete = [7].indexOf(_this.order.STATUS) !== -1 ? true : false;
_this.color = _this.isComplete ? '#04BE02' : 'red';
if (_this.isComplete) _this.MEMO = _this.order.SIGN_MEMO
_this.$vux.loading.hide()
_this.getOrderFiles()
}
).catch(
response => {
console.log(response, '请求失败')
}
)
},
getThOrder() {

},
getOrderFiles() {
let _this = this;
_this.$comapi.GetWebFile(_this.order.WORKNO, _this.$config.F_SRC.ps_order, res => {
if (res.length > 0) _this.hasOrderImg = true
_this.orderFiles = res
});
_this.$comapi.GetWebFile(_this.order.WORKNO, _this.$config.F_SRC.ps_demage, res => {
if (res.length > 0) _this.hasDemageImg = true
_this.demageFiles = res
});
_this.$comapi.GetWebFile(_this.order.WORKNO, _this.$config.F_SRC.th_order, res => {
_this.th_orderFiles = res
});
_this.$comapi.GetWebFile(_this.order.WORKNO, _this.$config.F_SRC.th_demage, res => {
_this.th_demageFiles = res
});
},
submitOrderFiles(file) {
let _this = this;
_this.$comapi.SaveWebFile(this.order.WORKNO, _this.$config.F_SRC.ps_order, file, function(res) {
if (res) _this.hasOrderImg = true
})
},
submitDemageFiles(file) {
let _this = this;
_this.$comapi.SaveWebFile(this.order.WORKNO, _this.$config.F_SRC.ps_order, file, function(res) {
if (res) _this.hasDemageImg = true
})
},
handleStep(STATUS, STATUS_NAME) {
if (STATUS == 7 && !this.hasOrderImg) {
this.$toast.text('请先上传送货交接单')
return
}
const sPara = {
SIGN_MEMO: this.MEMO,
ID: this.order.ID,
STATUS: STATUS,
SLAT: this.position.lat,
SLNG: this.position.lng,
ADDR: this.position.addr
};
var url = "Trans.ashx?action=Update_Status_DT"
if (sPara.STATUS == 3) sPara.DT_FIELD = 'DT_TH';
else if (sPara.STATUS == 4) sPara.DT_FIELD = 'DT_CQHUB_OUT';
else if (sPara.STATUS == 5) sPara.DT_FIELD = 'DT_CQ_OUT';
else if (sPara.STATUS == 7) sPara.DT_FIELD = 'DT_XH';

sPara.url = url
this.confirmTitle = STATUS_NAME
this.stepForm = sPara
this.showConfirm = true
},
onStepConfirm() {
if (this.isSubmit) return
this.isSubmit = true
this.$post(this.stepForm.url, this.stepForm).then(res => {
this.$toast.success('操作成功')
setTimeout(() => {
this.isSubmit = false
this.showConfirm = false
this.loadData()

}, 1000);
}).catch(res => {
setTimeout(function() {
this.isSubmit = false
this.showConfirm = false
}, 3000)
})
},
toSign() {
if (this.isSubmit) return;
this.isSubmit = true;
let param = {
ID: this.ID,
SIGN_MEMO: this.MEMO,
SLAT: this.position.lat,
SLNG: this.position.lng,
ADDR: this.position.addr,
STATUS: 6,
ALARM_INFO: JSON.stringify({
MSG_CODE: "TRANS_DONE",
BASE_ID: 22
})
};
this.$post('Trans.ashx?action=Update_Over', param).then(res => {
this.$toast.success('操作成功')
setTimeout(() => {
this.isSubmit = false
this.showConfirm = false
this.loadData()
}, 1000);
}).catch(res => {
this.isSubmit = false
this.showConfirm = false
})
},
toAbnormal() {
this.$router.push({
path: './abnormal?TYPE=0&ID=' + this.ID
})
}
}
}



// WEBPACK FOOTER //
// ./src/pages/Asus/Psd.vue